import { Deserializable } from '../../../../protocols/deserializable';
import { EmploymentStatusType } from '../../../../types/dto/employment-status-type';
import { StatusReasonType } from '../../../../types/dto/status-reason-type';
import { StatusReasonTypeId } from '../../../../enum/shared/status-reason-type-id';

export class UpdateEmploymentStatusSubmissionData implements Deserializable {
  public memberId!: number;
  public memberName!: string;
  public startDate!: string | null;
  public endDate!: string | null;
  public employmentStatusId!: number | null;
  public employmentStatus!: EmploymentStatusType | null;
  public employmentStatusChangeReasonId!: StatusReasonTypeId | null;
  public employmentStatusChangeReason!: StatusReasonType | null;
  public comment!: string | null;

  public onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;

    if (this.employmentStatus) {
      this.employmentStatus = Deserialize?.instanceOf(EmploymentStatusType, this.employmentStatus);
    }

    if (this.employmentStatusChangeReason) {
      this.employmentStatusChangeReason = Deserialize?.instanceOf(StatusReasonType, this.employmentStatusChangeReason);
    }
  }
}
